import { useEffect, useState } from "react";
import { formatPrice } from "../utils/formatUtils";
import api from "../api/api";

export default function TradeHistory() {
  const [trades, setTrades] = useState([]);
  useEffect(() => {
    async function fetchTrades() {
      try {
        const response = await api.get("/user/trades", { withCredentials: true });
        setTrades(response.data);
      } catch (err) {
        console.error("Failed to fetch trades:", err);
      }
    }
    fetchTrades();
  }, []);

  const hasTrades = trades.length > 0;

  function extractDate(isoString) {
    return isoString.split('T')[0];
  }

  return (
    <div className="container mx-auto p-4">
      <h2 className="text-2xl font-bold mb-4">Trade History</h2>

      {hasTrades ? (
        <>
          {/* Desktop table layout */}
          <div className="hidden lg:inline">
            <table className="w-full">
              <thead className="bg-blue-100 text-stone-600 text-sm text-left font-semibold">
                <tr>
                  <th className="p-4">Date</th>
                  <th className="p-4">Coin</th>
                  <th className="p-4">Type</th>
                  <th className="p-4">Amount</th>
                  <th className="p-4">Price</th>
                  <th className="p-4">Total</th>
                </tr>
              </thead>
              <tbody className="text-sm">
                {trades.map((trade) => (
                  <tr key={trade.id} className="border-t hover:bg-stone-100">
                    <td className="p-4">{extractDate(trade.timestamp)}</td>
                    <td className="p-4 font-semibold uppercase">{trade.symbol}</td>
                    <td className="p-4 font-semibold uppercase">{trade.type}</td>
                    <td className="p-4">{trade.quantity}</td>
                    <td className="p-4">${formatPrice(trade.price)}</td>
                    <td className="p-4 font-semibold">{trade.type === "buy" ? '-' : '+'}${formatPrice(trade.total_value)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Mobile card layout */}
          <div className="lg:hidden space-y-4 text-sm">
            {trades.map((trade) => (
              <div key={trade.id} className="border rounded-lg p-4">
                <div className="flex justify-between">
                  <span className="font-bold uppercase">{trade.symbol} {trade.type}</span>
                  <span className="font-bold">{trade.type === "buy" ? '-' : '+'}${formatPrice(trade.total_value)}</span>
                </div>
                <div className="flex justify-between text-stone-600">
                  <span>{extractDate(trade.timestamp)}</span>
                  <span>{(trade.quantity).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 6 })} coin{trade.quantity !== 1 && 's'} at ${formatPrice(trade.price)}</span>
                </div>
              </div>
            ))}
          </div>
        </>
      ) : (
        <div className="text-center text-gray-500 text-sm mt-8">
          No trade history available.
        </div>
      )}
    </div>
  );
}